import { useTheme } from '@mui/material';
import { green, grey } from '@mui/material/colors';
import React, { useCallback } from 'react';
import { OneLinkStatusEnum } from '../../../types/oneLink';
import { ReportsStatus } from '../../index';

const OneLinkStatus = ({ status }: { status: OneLinkStatusEnum }) => {
  const { sass } = useTheme();

  const getDataFromStatus = useCallback(() => {
    switch (status) {
      case OneLinkStatusEnum.Active:
        return { label: 'Active', color: green[500] };
      case OneLinkStatusEnum.NotActive:
        return { label: 'Inactive', color: grey[400] };
      default:
        return { label: 'Unknown', color: sass.white };
    }
  }, [status, sass.white]);

  const { label, color } = getDataFromStatus();

  return <ReportsStatus status={label} backgroundColor={color} />;
};

export default OneLinkStatus;
